import { render, staticRenderFns } from "./ProductLessonScheduleModal.vue?vue&type=template&id=051545c4&scoped=true&"
import script from "./ProductLessonScheduleModal.vue?vue&type=script&lang=ts&"
export * from "./ProductLessonScheduleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051545c4",
  null
  
)

export default component.exports